import { defaulted, object, unknown } from 'superstruct';
import { clamp, laterCoerce, parsableInteger } from '@arc/shared/util-superstruct';
export const PaginationQuery = object({
  /** Note: Pages on the HUB API are all 0-indexed. */
  page: clamp(parsableInteger(), {
    min: 0
  }),
  /**
   * It could be useful to specify `itemsPerPage = 0` to get `totalCount`
   * and other metadata about a collection without retrieving any items
   * in the collection. However, many of HUB's endpoints do not handle
   * this case correctly, so `itemsPerPage` has a lower bound of 1.
   */
  itemsPerPage: clamp(parsableInteger(), {
    min: 1,
    max: 1000
  })
});
export function PaginationQueryDefaulted(defaultItemsPerPage = 50) {
  return object({
    page: defaulted(PaginationQuery.schema.page, 0),
    itemsPerPage: clamp(
    // zeroDefaultedWorkaround needs to run before clamp.
    zeroDefaultedWorkaround(parsableInteger(), defaultItemsPerPage), {
      min: 1,
      max: 1000
    })
  });
}

/**
 * Augment a struct to replace `undefined` and `0` values with a default.
 *
 * This is a workaround for a design mistake where HUB's API accepted `itemsPerPage=0`
 * as valid, but did not apply any limit to the result set (i.e. HUB would return all
 * items without pagination) due to how TypeORM's `.take(0)` works.
 *
 * Simply clamping `itemsPerPage` to 1 <= x <= 1000 is a cleaner design, but this would
 * break several parts of HUB's UI that use 0 as a default `itemsPerPage`.
 */
// TODO Fix all places that use 0 as a default for itemsPerPage so that this workaround is no longer needed.
function zeroDefaultedWorkaround(struct, fallback) {
  return laterCoerce(struct, unknown(), value => value === undefined || value === 0 ? fallback : value);
}